import React from 'react'

const Words = () => {
  return (
    <div>Words</div>
  )
}

export default Words